import styled from '@emotion/styled';

const PercentagesWrapper = styled.div`
  display: flex;
  margin-bottom: 20px;
  font-family: Roboto;
  color: #4a4a4a;
`;

const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 24px;

  @media (min-width: ${(props) => props.theme.breakpoints.mobile_landscape}) {
    margin-right: 32px;
  }

  .label,
  .value {
    text-align: center;
    line-height: 20px;

    @media (min-width: ${(props) => props.theme.breakpoints.mobile_landscape}) {
      line-height: 30px;
    }
  }
`;

export { PercentagesWrapper, ItemWrapper };
